import { Component, Input, OnInit, inject } from '@angular/core';
import { AdditionalServiceVoice } from '@sales/modules/subscription/models/additional-service-voice.model';
import { PriceType } from '@shared/pipes/price-format.pipe';
import { ControlContainer, FormGroupDirective, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormStatus } from '@sales/models/form-status.enum';
import { SimCardDelivery, SimCardType } from '@sales/models/simcard.model';
import { VoiceProduct } from '@shared/models/voice-product.model';
import { PriceFormatPipe } from '@app/shared/pipes/price-format.pipe';
import { AsyncPipe } from '@angular/common';
import { SpinnerComponent } from '@app/shared/components/atoms/spinner/spinner.component';
import { IceRadioButtonComponent } from '@app/shared/components/atoms/ice-radio-button/ice-radio-button.component';
import { IceSelectBoxComponent } from '@app/shared/components/molecules/ice-select-box/ice-select-box.component';
import { IceInputFieldComponent } from '@app/shared/components/molecules/ice-input-field/ice-input-field.component';
import { FormValidationService } from '@app/shared/services/form-validation.service';
import { IncludedServicesService } from '@app/sales/modules/subscription/services/included-services.service';

@Component({
  selector: 'app-additional-service',
  templateUrl: './additional-service.component.html',
  styleUrls: ['./additional-service.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  imports: [
    IceSelectBoxComponent,
    IceInputFieldComponent,
    IceRadioButtonComponent,
    FormsModule,
    ReactiveFormsModule,
    SpinnerComponent,
    AsyncPipe,
    PriceFormatPipe,
  ],
})
export class AdditionalServiceComponent implements OnInit {
  formGroupDirective = inject(FormGroupDirective);
  private includedServices = inject(IncludedServicesService);

  FormStatus = FormStatus;
  SimCardType = SimCardType;
  SimCardDelivery = SimCardDelivery;
  PriceType = PriceType;
  getSimCardErrorTexts = FormValidationService.getSimCardErrorTexts;

  @Input() product: VoiceProduct;
  @Input() additionalService: AdditionalServiceVoice;
  @Input() selectionControlName: string;
  @Input() iccControlName: string;
  @Input() simDeliveryControlName: string;
  selectionControl: FormControl;

  get iccField() {
    return this.formGroupDirective?.form?.get(this.iccControlName) as FormControl;
  }

  get isSelected(): boolean {
    return this.selectionControl?.value;
  }

  get isDeliveredInStore(): boolean {
    return this.formGroupDirective?.form?.get(this.simDeliveryControlName)?.value === SimCardDelivery.InStore;
  }

  get isIncluded(): boolean {
    return this.includedServices.isIncluded(this.additionalService);
  }

  get isLockedIn(): boolean {
    return this.isIncluded && this.isSelected;
  }

  ngOnInit() {
    this.selectionControl = this.formGroupDirective?.form?.get(this.selectionControlName) as FormControl;

    if (this.additionalService.isDataSimCard && this.product?.replaceDataSimIcc) {
      this.selectionControl.disable();
    }

    if (this.additionalService.isTwinSimCard && this.product?.replaceTwinSimIcc) {
      this.selectionControl.disable();
    }
  }

  getSimCardTypeForService(): SimCardType {
    if (this.additionalService?.isDataSimCard) {
      return SimCardType.Data;
    }

    if (this.additionalService?.isTwinSimCard) {
      return SimCardType.Twin;
    }

    return SimCardType.Voice;
  }
}
